<template>
  <div class="menuBox">
    <p id="mainContainer">
      <span
        @click.stop="selectMenu(item)"
        :class="[menuRes && menuRes.identifier === item.identifier ? 'menuItem active' : 'menuItem ']"
        v-for="(item, i) in menuList"
        :id="item.identifier"
        :key="item.identifier + i"
        >{{ item.name }}</span
      >
    </p>
    <van-icon tag="div" class="menuBars" name="bars" size="30" color="#555" @click="showMenuListNumFn" />
  </div>
  <div class="conditionBox">
    <p class="dealerLabel">销售经销商:</p>
    <div class="selectFieldBox fvlr" @click="showNum += 1">
      <span class="ellipsis" :class="{ black: hasDealer }">{{ dealer.name || '请选择经销商' }}</span>
      <van-icon name="arrow-down" />
    </div>
    <p class="fvlrw conditions">
      <span
        @click.stop.prevent="selectCondition(item)"
        :class="[conditionRes && conditionRes.id === item.id ? 'fvl themeColor active' : 'fvl', item.disable ? 'disable' : '']"
        v-for="item in conditionList"
        :key="item.id"
        >{{ item.label
        }}<van-icon @click.self.stop="changeSort(item)" v-show="item.sort" :name="item.direction == 'desc' ? 'ascending' : 'descending'" size="16"
      /></span>
    </p>
  </div>

  <SwitchDealer :showNum="showNum" @dealerFn="dealerFn" from="shopList" />
  <teleport to="#dialogMenuList">
    <PopUp ref="popUpRef" :showPopUp="showMenuListNum" :datas="{ title: '请选择品类' }">
      <MenuList :datas="menuPopUpListData" @clickBtn="changeMenuSelect" />
    </PopUp>
  </teleport>
</template>

<script>
import { reactive, toRefs, ref, onMounted, watch, computed, onUnmounted } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import { getDistance } from '@/util'
import { getDefaultDealer } from '@/api/tyre'
import SwitchDealer from '@/components/dealer/SwitchDealer'
import PopUp from '@/components/common/PopUp'
import MenuList from '@/components/shop/MenuList'
import useCondition, { getDealerDetailByGscode } from '@/hooks/directSales/useCondition'
import { showToast } from '@/util/couponCollection'

export default {
  name: 'Condition',
  emits: ['change'],
  props: {},
  components: { SwitchDealer, PopUp, MenuList },
  setup(props, { emit }) {
    const mountEle = document.createElement('div')
    mountEle.id = 'dialogMenuList'
    document.body.appendChild(mountEle)
    // 清空节点
    onUnmounted(() => {
      document.body.removeChild(mountEle)
    })
    let store = useStore()
    const router = useRouter()
    let { loyaltyDealerInfo: dealerInfo } = store.state
    let {
      menuPopUpListData,
      menuList,
      conditionList,
      showMenuListNum,
      menuRes,
      menuPopUpRes,
      conditionRes,
      setVal,
      selectMenu,
      changeSort,
      changeMenuSelect,
      selectCondition,
      showMenuListNumFn,
      popUpRef
    } = useCondition()
    const state = reactive({
      menuRes,
      dealer: dealerInfo && dealerInfo.name ? dealerInfo : { name: '请选择经销商' },
      hasDealer: !!dealerInfo?.id,
      showNum: 1
    })

    const getDefaultDealerFn = async () => {
      if (!dealerInfo.gs_code && !dealerInfo?.gsCode) {
        let position = store.state?.position || {}
        let { lat: latitude = '', lng: longitude = '' } = position
        let param = { productType: 1, latitude, longitude }
        let data = await getDefaultDealer(param)
        let gsCode = data?.gs_code || data?.gsCode
        data.gs_code = data.gsCode = gsCode
        data.distance = getDistance(data.distance)
        state.dealer = data
        state.hasDealer = !!data.gsCode
        if (!gsCode && (!latitude || !longitude)) {
          showToast('无法定位所在地点，请手动选择经销商后查看相关信息')
        }
        store.dispatch('setLoyaltyDealerInfo', state.dealer)
      } else {
        state.dealer = dealerInfo || { name: '请选择经销商' }
        state.hasDealer = !!(dealerInfo.gs_code || dealerInfo.gsCode)
      }
    }
    watch([() => state.menuRes, () => menuPopUpRes, () => state.dealer, () => conditionRes], async ([menuRes, menuPopUpRes, dealer, conditionRes]) => {
      let gsCode = dealer.gs_code || dealer.gsCode
      dealer.gs_code = dealer.gsCode = gsCode
      emit('change', { menuRes: menuRes, menuPopUpRes, dealer, conditionRes })
    })
    watch(
      () => store.state.position,
      n => {
        let { loyaltyDealerInfo: dealerInfo } = store.state
        let gsCode = dealerInfo?.gs_code || dealerInfo?.gsCode
        if (gsCode) {
          if (!dealerInfo.distance) {
            //有gscode and 没有距离 => 刷新距离
            n && n.lat && getDealerDetailByGscode({ gsCode })
          }
        } else {
          // 没有经销商 and 有经纬度 => 尝试再次获取距离最近的经销商
          n && n.lat && getDefaultDealerFn()
        }
      }
    )
    // //以下两个watch不要合并，专门拆开的不要合并
    // watch([() => menuRes, () => menuPopUpRes, () => conditionRes], async ([menuRes, menuPopUpRes, conditionRes]) => {
    //   emit('change', { menuRes, menuPopUpRes, dealer: state.dealer, conditionRes })
    // })
    // watch(
    //   () => state.dealer,
    //   async (dealer, dealerOld) => {
    //     let gsCode = dealer.gs_code || dealer.gsCode
    //     let gsCodeOld = dealerOld.gs_code || dealerOld.gsCode
    //     if (gsCodeOld === gsCode && gsCode) {
    //       return
    //     }
    //     dealer.gs_code = dealer.gsCode = gsCode
    //     emit('change', { menuRes, menuPopUpRes, dealer, conditionRes })
    //   }
    // )
    const dealerFn = val => {
      let gsCode = val.gs_code || val.gsCode
      val.gs_code = val.gsCode = gsCode
      state.dealer = val
      state.hasDealer = true
    }

    onMounted(async () => {
      getDefaultDealerFn()
    })
    return {
      ...toRefs(state),
      menuPopUpListData,
      menuList,
      conditionList,
      showMenuListNum,
      menuRes,
      menuPopUpRes,
      conditionRes,
      dealerFn,
      selectMenu,
      changeSort,
      changeMenuSelect,
      selectCondition,
      showMenuListNumFn,
      popUpRef
    }
  }
}
</script>

<style lang="scss" scoped>
.selectFieldBox {
  height: 40px;
  margin-bottom: 8px;
  padding: 0 12px;
  border: 1px solid #eee;
  background-color: #fff;
  .black {
    color: #000;
  }
}

.menuBox {
  position: relative;
  width: 100%;
  overflow-x: hidden;
  padding: 0 20px;
  margin-bottom: 10px;
  font-size: 13px;
  background-color: #fff;
  box-sizing: border-box;

  p {
    padding-right: 250px;
    min-width: 100%;
    white-space: nowrap;
    overflow-x: scroll;
    text-align: left;
    .active {
      font-weight: 600;
      color: #3088c5;
    }
  }

  .menuItem {
    display: inline-block;
    padding: 15px 10px;
    color: #333;
    font-weight: 400;
  }
  .menuItem:last-child {
    margin-right: 60px;
    // color: red;
  }
  p::-webkit-scrollbar {
    display: none;
  }
  .menuBars {
    position: absolute;
    right: 0px;
    top: 0;
    bottom: 0;
    height: 100%;
    padding: 6px 18px 0;
    vertical-align: baseline;
    background: #fff;
    box-shadow: -2px 2px 15px #aaa;
    box-sizing: border-box;
  }
}
.conditionBox {
  padding: 0 20px;
  font-size: 13px;
  .dealerLabel {
    text-align: left;
  }
  .conditions {
    padding: 10px;
    color: #333;
  }
  .active {
    font-weight: 600;
  }
  .disable {
    color: #999;
  }
  .van-icon {
    padding-left: 5px;
  }
}
</style>
